'use client';

/**
 * Bridges the consent decision to Sentry Session Replay (GitLab #649, D9).
 *
 * Renders nothing. It exists as a component rather than a call inside
 * `ConsentProvider` because the provider is the compliance state machine and
 * is unit-tested as one; a vendor SDK reaching into it would have to be
 * mocked by every one of those tests. Mounted beside `GtmLoader`, replay is
 * treated as what it is — one more thing the analytics category switches on.
 *
 * Surfaces with no `ConsentSurface` (the admin console) never mount this, so
 * replay is never added there. That is the intended reading of "consent":
 * nobody has been asked, so nobody is recorded.
 */
import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { syncSentryReplayConsent } from '@/lib/analytics/sentryReplayConsent';
import { useConsent } from './ConsentProvider';
export function SentryReplayConsent() {
  const $ = _c(3);
  const {
    isReady,
    categories
  } = useConsent();
  const granted = isReady && categories.analytics;
  let t0;
  let t1;
  if ($[0] !== granted) {
    t0 = () => {
      syncSentryReplayConsent(granted);
    };
    t1 = [granted];
    $[0] = granted;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
}